import React from 'react'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Pagination from '@mui/material/Pagination'
import Typography from '@mui/material/Typography'
import { useServiceHistory } from './hooks/useServiceHistory'
import { ServiceListItem } from './components/ServiceListItem'
import { ServiceListSkeleton } from './components/ServiceListSkeleton'
import { EmptyServiceHistory } from './components/EmptyServiceHistory'

interface ServiceHistoryTabProps {
  locationId: string | null | undefined
  tabActive: boolean
}

export function ServiceHistoryTab({
  locationId,
  tabActive,
}: ServiceHistoryTabProps) {
  const { services, loading, error, page, setPage, total, pageSize } =
    useServiceHistory({
      locationId,
      enabled: tabActive,
    })

  if (loading && services.length === 0) {
    return <ServiceListSkeleton count={3} />
  }

  if (error) {
    return <Alert severity="error">Failed to load service history.</Alert>
  }

  if (!loading && services.length === 0) {
    return <EmptyServiceHistory />
  }

  const totalPages = Math.ceil(total / pageSize)

  return (
    <>
      <Paper variant="outlined" sx={{ p: 1.5, opacity: loading ? 0.5 : 1 }}>
        <Typography variant="caption" sx={{ textTransform: 'uppercase' }}>
          Service History
        </Typography>

        {services.map((service, index) => (
          <ServiceListItem
            key={`service-${service.id}-${index}`}
            service={service}
          />
        ))}
      </Paper>

      {totalPages > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1.5 }}>
          <Pagination
            count={totalPages}
            page={page + 1}
            color="primary"
            size="small"
            disabled={loading}
            showFirstButton
            showLastButton
            onChange={(_, pageNumber) => setPage(pageNumber - 1)}
          />
        </Box>
      )}
    </>
  )
}

ServiceHistoryTab.displayName = 'ServiceHistoryTab'
